import { RefreshCw, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTabsContext } from "@/providers/tabs-provider";
import { cn } from "@/lib/utils";

export function WorkbenchTabBar() {
  const { tabs, activeId, closeTab, focusTab } = useTabsContext();
  const location = useLocation();

  return (
    <div
      className="flex shrink-0 items-end gap-0 overflow-x-auto border-b border-border/60 bg-muted/20 px-4 scrollbar-none sm:px-5"
      style={{ minHeight: 42 }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeId || location.pathname === tab.path;
        const Icon = tab.icon;
        return (
          <div
            key={tab.id}
            onClick={() => focusTab(tab.id)}
            className={cn(
              "group relative -mb-px flex h-9 max-w-[200px] shrink-0 cursor-pointer select-none items-center gap-2 border-b-2 px-3 transition-colors sm:px-3.5",
              isActive
                ? "border-primary bg-background text-foreground"
                : "border-transparent text-muted-foreground hover:border-border hover:bg-background/70 hover:text-foreground",
            )}
          >
            <Icon
              className={cn(
                "h-3.5 w-3.5 shrink-0",
                isActive ? "text-primary" : "text-muted-foreground/70 group-hover:text-foreground",
              )}
            />
            <span
              className={cn(
                "truncate text-[13px] tracking-tight",
                isActive ? "font-semibold" : "font-medium",
              )}
            >
              {tab.label}
            </span>

            {isActive && (
              <button
                type="button"
                className="ml-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md text-muted-foreground/70 transition-colors hover:bg-muted hover:text-foreground"
                onClick={(e) => {
                  e.stopPropagation();
                  window.location.reload();
                }}
                aria-label={`Refresh ${tab.label}`}
              >
                <RefreshCw className="h-3 w-3" />
              </button>
            )}

            {!tab.pinned && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  closeTab(tab.id);
                }}
                className={cn(
                  "flex h-5 w-5 shrink-0 items-center justify-center rounded-md transition-all",
                  isActive
                    ? "text-muted-foreground/70 hover:bg-muted hover:text-foreground"
                    : "text-muted-foreground/50 opacity-0 hover:bg-muted hover:text-foreground group-hover:opacity-100",
                )}
                aria-label={`Close ${tab.label}`}
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </div>
        );
      })}

      <div className="min-w-4 flex-1" />
    </div>
  );
}
